module.exports = __webpack_public_path__ + "img/04.552bf5af.png";